import {
    localizeAbc,
    solfaNameParser,
    i18nSolfa,
    ABCnames,
    lengthenSolfa,
} from "../../../../common/parameters";

const solfasForInterval = [
    "d,",
    "di,",
    "r,",
    "ri,",
    "m,",
    "f,",
    "fi,",
    "s,",
    "si,",
    "l,",
    "li,",
    "t,",
    "d",
    "di",
    "r",
    "ri",
    "m",
    "f",
    "fi",
    "s",
    "si",
    "l",
    "li",
    "t",
    "d’",
    "di’",
    "r’",
    "ri’",
    "m’",
    "f’",
    "fi’",
    "s’",
    "si’",
    "l’",
    "li’",
    "t’",
    "d’’",
];

export const solfaOptions = (locale: string, solfaShort: boolean, solfaKam: boolean) =>
    solfasForInterval.map(solfa => {
        let value = ((solfaNameParser.indexOf(solfa.slice(0, 1)) - 1) * 7) % 12;
        if (value < 0) value += 12;
        if (solfa.slice(-1) === ",") value -= 12;
        if (solfa.slice(-1) === "’") value += 12;
        if (solfa.slice(-2, -1) === "’") value += 12;
        if (solfa.slice(1, 2) === "i") value++;

        return {
            value,
            label: lengthenSolfa(i18nSolfa(solfa, locale, solfaKam), locale, solfaShort),
        };
    });

export const ABCOptionsRange = (locale: string) =>
    ABCnames.map(abc => {
        return {
            value: abc.value,
            label: localizeAbc(abc.label, locale),
        };
    }).reverse();
